<template>
    <div class="activity-indicator-dots">
        <div class="activity-indicator-dots-bounce1" />
        <div class="activity-indicator-dots-bounce2" />
        <div class="activity-indicator-dots-bounce3" />
    </div>
</template>